import * as React from 'react';
import { EngineRenderers } from '@websky/core/src/renderProps';
import BaggageBodyCore from '@websky/core/src/Baggage/UpgradeBaggageDialog/components/BaggageBody/BaggageBody';
import { useSelector } from 'react-redux';
import { getBaggageTab } from '@websky/core/src/Baggage/UpgradeBaggageDialog/store/selector';
import Notification from '@websky/core/src/Notification';
import { InfoMessageTypeEnum } from '@websky/graphql';
import { useTranslation } from 'react-i18next';

const WZ_PET_RFICS = ['0BT', '021', '0BS', '0AY'];

const BaggageBody: EngineRenderers['renderBaggageBody'] = props => {
	const baggageTab = useSelector(getBaggageTab);

	const isShowZiaPetControlNoticeForRegWings =
		props.segments.some(segment => segment.departure?.airport?.iata === 'ZIA') && WZ_PET_RFICS.includes(baggageTab);

	const { t } = useTranslation('Baggage');

	return (
		<>
			<BaggageBodyCore {...props} />

			{isShowZiaPetControlNoticeForRegWings && (
				<Notification
					status={InfoMessageTypeEnum.Warning}
					type="context"
					infoMessage={{
						text: t('ZIA_pet_control_warning'),
						type: InfoMessageTypeEnum.Warning,
						code: ''
					}}
				/>
			)}
		</>
	);
};

export default BaggageBody;
